import { useMutation } from '@tanstack/react-query';
import { enterRaffleMutation } from '@phoenix/team-m/my-tool-shed/frontend/domain/service/benefits-api.graphql';
import { AnswerFormat } from '@phoenix/team-m/my-tool-shed/frontend/domain/generated/graphql';

import { useGraphqlFetcher } from '../use-graphql-fetcher';

interface RaffleParticipationResponse {
  errors?: any;
  enterRaffle: {
    raffleId: string;
    participation: {
      registration: Date;
    };
  };
}

export type EnterRaffleVariables = {
  raffleId: string;
  newsletterConsent: boolean;
  answers: {
    id: string;
    type: AnswerFormat | undefined;
    value: string;
  }[];
};

export const useRaffleParticipation = () => {
  const queryFetcher = useGraphqlFetcher<RaffleParticipationResponse>(
    enterRaffleMutation,
    process.env.NEXT_PUBLIC_MARKETING_GRAPHQL_ENDPOINT
  );

  return useMutation({
    mutationFn: async (variables: EnterRaffleVariables) => await queryFetcher(variables),
  });
};
